import { api } from "./api";

// ---------- Tienda (vendedor) ----------
export async function apiGetTienda() {
  const { data } = await api.get("/marketplace/tienda");
  return data.tienda; // null si no existe
}
export async function apiCrearTienda(payload, estado = "en_revision") {
  const { data } = await api.post(`/marketplace/tienda?estado=${estado}`, payload);
  return data;
}
export async function apiEditarTienda(payload) {
  const { data } = await api.put("/marketplace/tienda", payload);
  return data;
}

// ---------- Productos (vendedor) ----------
export async function apiGetProductos() {
  const { data } = await api.get("/marketplace/productos");
  return data.items || [];
}
export async function apiCrearProducto(payload, estado = "borrador") {
  const { data } = await api.post(`/marketplace/productos?estado=${estado}`, payload);
  return data;
}
export async function apiEditarProducto(id, payload, estado) {
  const q = estado ? `?estado=${estado}` : "";
  const { data } = await api.put(`/marketplace/productos/${id}${q}`, payload);
  return data;
}
export async function apiAccionProducto(id, accion) {
  const { data } = await api.post(`/marketplace/productos/${id}/${accion}`);
  return data;
}
export async function apiEliminarProducto(id) {
  await api.delete(`/marketplace/productos/${id}`);
}

// ---------- Cursos (vendedor) ----------
export async function apiGetCursos() {
  const { data } = await api.get("/marketplace/cursos");
  return data.items || [];
}
export async function apiCrearCurso(payload, estado = "borrador") {
  const { data } = await api.post(`/marketplace/cursos?estado=${estado}`, payload);
  return data;
}
export async function apiEditarCurso(id, payload, estado) {
  const q = estado ? `?estado=${estado}` : "";
  const { data } = await api.put(`/marketplace/cursos/${id}${q}`, payload);
  return data;
}
export async function apiAccionCurso(id, accion) {
  const { data } = await api.post(`/marketplace/cursos/${id}/${accion}`);
  return data;
}
export async function apiEliminarCurso(id) {
  await api.delete(`/marketplace/cursos/${id}`);
}

// ---------- Admin · moderación ----------
export async function apiAdminPendientes() {
  const { data } = await api.get("/marketplace/admin/pendientes");
  return data;
}
export async function apiAdminListado(estados) {
  const { data } = await api.get(`/marketplace/admin/listado?estado=${encodeURIComponent(estados)}`);
  return data.items || [];
}
export async function apiAdminResumen() {  const { data } = await api.get("/marketplace/admin/resumen");
  return data;
}
export async function apiAdminTareasPendientes() {
  const { data } = await api.get("/marketplace/admin/tareas-pendientes");
  return data; // { total, tiendas, productos, cursos, retiros, reembolsos }
}
export async function apiAdminModerar(payload) {
  const { data } = await api.post("/marketplace/admin/moderar", payload);
  return data;
}

// ---------- Archivos (Object Storage · Fase 5B) ----------
export async function apiSubirArchivo(file, scope, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("scope", scope);
  const { data } = await api.post("/marketplace/files", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data; // { id, ref, url, filename, mime, size, scope, visibility }
}
export async function apiEliminarArchivo(id) {
  await api.delete(`/marketplace/files/${id}`);
}
export async function apiUrlDescarga(id) {
  const { data } = await api.get(`/marketplace/files/${id}/download`);
  return data; // { url, filename }
}
// Extrae el id de archivo desde una ref 'mf:{id}' o una URL /marketplace/files/{id}
export function fileIdFrom(value) {
  if (!value) return null;
  if (value.startsWith("mf:")) return value.slice(3);
  const m = value.match(/\/marketplace\/files\/([a-fA-F0-9]{24})/);
  return m ? m[1] : null;
}

// ---------- Catálogo público (Fase 6A · solo lectura) ----------
export async function apiPublicHome() {
  const { data } = await api.get("/marketplace/public/home");
  return data;
}
export async function apiPublicItems(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const { data } = await api.get(`/marketplace/public/items?${qs}`);
  return data;
}
export async function apiPublicProducto(id) {
  const { data } = await api.get(`/marketplace/public/producto/${id}`);
  return data;
}
export async function apiPublicCurso(id) {
  const { data } = await api.get(`/marketplace/public/curso/${id}`);
  return data;
}
export async function apiPublicTienda(sid, params = {}) {
  const qs = new URLSearchParams(params).toString();
  const { data } = await api.get(`/marketplace/public/tienda/${sid}?${qs}`);
  return data;
}

// ---------- Uso y cuotas de almacenamiento (Fase 6) ----------
export async function apiUso() {
  const { data } = await api.get("/marketplace/uso");
  return data;
}
export async function apiAdminAlmacenamiento() {
  const { data } = await api.get("/marketplace/admin/almacenamiento");
  return data;
}
export async function apiAdminMantenimiento() {
  const { data } = await api.post("/marketplace/admin/mantenimiento");
  return data;
}

export function bytesLegible(n) {
  const b = Number(n || 0);
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(1)} MB`;
  return `${(b / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

// ---------- Membresía Marketplace (Fase 6) ----------
export async function apiMembresia() {
  const { data } = await api.get("/marketplace/membresia");
  return data;
}

// ---------- Carrito de compras (Fase 6) ----------
export async function apiGetCarrito() {
  const { data } = await api.get("/marketplace/carrito");
  return data;
}
export async function apiAddCarrito(tipo, itemId) {
  const { data } = await api.post("/marketplace/carrito", { tipo, item_id: itemId });
  return data;
}
export async function apiRemoveCarrito(tipo, itemId) {
  const { data } = await api.delete(`/marketplace/carrito/${tipo}/${itemId}`);
  return data;
}
export async function apiClearCarrito() {
  const { data } = await api.delete("/marketplace/carrito");
  return data;
}

// ---------- Checkout, órdenes y Mis Compras (Fase 6) ----------
export async function apiCheckout(originUrl, acceptedTerms = false, termsVersion = "") {
  const { data } = await api.post("/marketplace/checkout", { origin_url: originUrl, accepted_terms: acceptedTerms, terms_version: termsVersion });
  return data; // { url, order_id } o { gratis, order_id, url:null }
}
export async function apiOrderStatus(orderId) {
  const { data } = await api.get(`/marketplace/orders/status/${orderId}`);
  return data; // { status, payment_status, order_id }
}
export async function apiMisCompras() {
  const { data } = await api.get("/marketplace/mis-compras");
  return data;
}
export async function apiDescargarArchivo(fileId) {
  const { data } = await api.get(`/marketplace/files/${fileId}/download`);
  return data; // { url, filename }
}

// ---------- Comisiones · Saldo · Retiros (Fase 7A) ----------
export async function apiComisiones() {
  const { data } = await api.get("/marketplace/comisiones");
  return data;
}
export async function apiLedger() {
  const { data } = await api.get("/marketplace/ledger");
  return data;
}
export async function apiSolicitarRetiro(monto, metodo, datos) {
  const { data } = await api.post("/marketplace/retiros", { monto, metodo, datos });
  return data;
}
export async function apiMisRetiros() {
  const { data } = await api.get("/marketplace/retiros");
  return data;
}
export async function apiAdminRetiros(estado) {
  const { data } = await api.get("/marketplace/admin/retiros", { params: estado ? { estado } : {} });
  return data;
}
export async function apiAprobarRetiro(wid) {
  const { data } = await api.post(`/marketplace/admin/retiros/${wid}/aprobar`);
  return data;
}
export async function apiRechazarRetiro(wid, motivo) {
  const { data } = await api.post(`/marketplace/admin/retiros/${wid}/rechazar`, { motivo });
  return data;
}
export async function apiPagarRetiro(wid, referencia) {
  const { data } = await api.post(`/marketplace/admin/retiros/${wid}/pagar`, { referencia });
  return data;
}

// ---------- Estadísticas y reportes (Fase 7B) ----------
export async function apiEstadisticas(desde, hasta) {
  const { data } = await api.get("/marketplace/estadisticas", { params: { desde, hasta } });
  return data;
}
export async function apiAdminEstadisticas(desde, hasta) {
  const { data } = await api.get("/marketplace/admin/estadisticas", { params: { desde, hasta } });
  return data;
}
export async function apiAdminConfig() {
  const { data } = await api.get("/marketplace/admin/config");
  return data;
}

// ---------- Configuración Comercial (comisiones dinámicas + precio mínimo) ----------
export async function apiConfigComercial() {
  const { data } = await api.get("/marketplace/config-comercial");
  return data;
}
export async function apiAdminConfigComercial() {
  const { data } = await api.get("/marketplace/admin/config-comercial");
  return data;
}
export async function apiGuardarConfigComercial(payload) {
  const { data } = await api.put("/marketplace/admin/config-comercial", payload);
  return data;
}

// ---------- Configuración del vendedor (Fase 7E) ----------
export async function apiGetConfiguracion() {
  const { data } = await api.get("/marketplace/configuracion");
  return data;
}
export async function apiGuardarConfiguracion(payload) {
  const { data } = await api.put("/marketplace/configuracion", payload);
  return data;
}

// ---------- Reembolsos e incidencias (Fase 7C) ----------
export async function apiSolicitarReembolso(tipo, itemId, motivo) {
  const { data } = await api.post("/marketplace/reembolsos", { tipo, item_id: itemId, motivo });
  return data;
}
export async function apiMisReembolsos() {
  const { data } = await api.get("/marketplace/reembolsos");
  return data;
}
export async function apiAdminReembolsos(estado) {
  const { data } = await api.get("/marketplace/admin/reembolsos", { params: estado ? { estado } : {} });
  return data;
}
export async function apiAprobarReembolso(rid, comentario) {
  const { data } = await api.post(`/marketplace/admin/reembolsos/${rid}/aprobar`, { comentario });
  return data;
}
export async function apiRechazarReembolso(rid, comentario) {
  const { data } = await api.post(`/marketplace/admin/reembolsos/${rid}/rechazar`, { comentario });
  return data;
}
async function _descargarCsv(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click();
  a.remove(); window.URL.revokeObjectURL(url);
}
export function apiEstadisticasCsv(desde, hasta) {
  return _descargarCsv("/marketplace/estadisticas/csv", { desde, hasta }, "ventas_construlink.csv");
}
export function apiAdminEstadisticasCsv(desde, hasta) {
  return _descargarCsv("/marketplace/admin/estadisticas/csv", { desde, hasta }, "ventas_admin_construlink.csv");
}
